import React from "react";
import PropTypes from "prop-types";
import { Container, Header, Icon, Message } from "semantic-ui-react";

const AdminHome = ({ user }) => {
  const welcomeStyle = {
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    borderRadius: "16px",
    padding: "3rem 2rem",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    textAlign: "center",
    marginTop: "3rem",
  };

  return (
    <Container fluid style={{ maxWidth: "100%" }}>
      <div
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderRadius: "20px",
          padding: "2rem",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={welcomeStyle}>
          <Icon
            name="shield alternate"
            size="huge"
            color="green"
            style={{ marginBottom: "1rem" }}
          />

          <Header as="h2" color="green" style={{ marginBottom: "1rem" }}>
            Welcome, {user.fullName}
          </Header>

          <Header
            as="h4"
            color="grey"
            style={{ fontWeight: "normal", marginBottom: "2rem" }}
          >
            System Administrator Dashboard
          </Header>

          <Message
            info
            size="small"
            style={{ maxWidth: "500px", margin: "0 auto" }}
          >
            <Message.Header>Administrative Tools</Message.Header>
            <p style={{ fontSize: "1.1em", lineHeight: "1.6" }}>
              All administrative functions are available through the sidebar
              navigation. Use the <strong>Library Activity Monitor</strong> and{" "}
              <strong>Administration </strong>
              sections to manage the system.
            </p>
          </Message>
        </div>
      </div>
    </Container>
  );
};

AdminHome.propTypes = {
  user: PropTypes.object.isRequired,
  fullName: PropTypes.string.isRequired,
};

export default AdminHome;
